export const actions = {
    STORE_WORKSPACE_CONFIG: "STORE_WORKSPACE_CONFIG",
};

export const initialState = {
    configList: [],
};

export default (state = initialState, { type, configList }: { type: string; configList: [] }) => {
    switch (type) {
        case actions.STORE_WORKSPACE_CONFIG: {
            return {
                ...state,
                configList,
            };
        }

        default:
            return state;
    }
};
